import { IconMinus, IconPlus, IconTrashFilled, IconX } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useContext, useRef, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { toast } from 'sonner';
import { uploadImage } from '../../../../api/api.global';
import { getApi, postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import IconButton from '../../../../components/Buttons/IconButton';
import ShortLinkDropdown from '../../../../components/DropDown/ShortLinkDropdown';
import ToggleBtn from '../../../../components/Toggle/ToggleBtn';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal';

const LinkBlockOfCard = ({ dragButton, linkId, callback, data }) => {

    function ContextAwareToggle({ eventKey, callback }) {
        const { activeEventKey } = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(
            eventKey,
            () => callback && callback(eventKey),
        );

        const isCurrentEventKey = activeEventKey === eventKey;

        return (
            <div className="flex items-center rounded-md bg-[#E8EDFC] gap-3 p-2 cursor-pointer" onClick={decoratedOnClick}>
                {dragButton}
                <p className='mb-0 text-sm font-semibold'>Links</p>
                <div className="ms-auto"></div>
                <ToggleBtn state={data?.status == 1} onClickFunction={(e) => onBlockStatusUpdate(e)} />
                <button className='bg-white p-1.5 rounded-full' onClick={decoratedOnClick}>{isCurrentEventKey ? <IconMinus size={20} /> : <IconPlus size={20} />}</button>
            </div>
        );
    }

    const [file, setFile] = useState(null);
    const imageUploadInputRef = useRef(null);
    const [linkTypeRadio, setLinkTypeRadio] = useState('new');
    const [linkList, setLinkList] = useState([]);
    const [searchInput, setSearchInput] = useState('');

    async function getList(e) {
        setSearchInput(e.target.value);
        let resp = await getApi(urlApi.searchActiveLinks + "?search=" + e.target.value);
        setLinkList(resp?.data || []);
    }

    const handleImageChange = (e) => {
        const localFile = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (localFile && localFile.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            setFile(null);
            e.target.value = null;
        } else {
            onImageChange(localFile)
            setFile(localFile);
        }
    }

    async function update(postDetails) {
        let postData = {
            linkId: linkId,
            postData: postDetails
        }
        let resp = await postApi(postData, urlApi.editBlockDataOfCard);
        loadingHide();
        if (resp?.responseCode === 200) {
            if (callback) {
                callback();
            }
        }
        if (resp.responseCode === 500) {
            toast.error(resp.message);
        }
    }

    const onBlockStatusUpdate = (e) => {
        e.stopPropagation();
        loadingShow();
        let status = data?.status == 1 ? 2 : 1;
        let postDetails = [{
            "key": "links.status",
            "value": status
        }]
        update(postDetails);
    }

    const onTitleChange = (e) => {
        let postDetails = [{
            "key": "links.title",
            "value": e.target?.value?.trim()
        }]
        update(postDetails);
    }

    const onDescriptionChange = (e) => {
        let postDetails = [{
            "key": "links.description",
            "value": e.target?.value?.trim()
        }]
        update(postDetails);
    }

    const onLinkChange = (e) => {
        let postDetails = [{
            "key": "links.link",
            "value": e.target?.value?.trim()
        }]
        update(postDetails);
    }

    const onCancel = () => {
        document.getElementById('destinationUrl').value = '';
        document.getElementById('search-existing-link-input').value = '';
        setLinkList([]);
        setSearchInput('');
    }

    const onImageChange = async (image) => {
        loadingShow();
        let postDetails = [{
            "key": "links.image",
            "value": await uploadImage(image, 'advy-card-links')
        }]
        update(postDetails);
    };

    const onRemoveImage = () => {
        let postDetails = [{
            "key": "links.image",
            "value": ''
        }]
        update(postDetails);
    }

    function onSelectLink(linkData) {
        document.getElementById('destinationUrl').value = linkData.mainLink;
        document.getElementById('search-existing-link-input').value = linkData.shortLink;
        let postDetails = [{
            "key": "links.link",
            "value": linkData.mainLink
        }]
        update(postDetails);
        setLinkList([]);
    }

    return (

        <div className='w-full rounded-md border border-[#E8EDFC]'>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <ContextAwareToggle eventKey={"0"} />
                    <Accordion.Body>
                        <div className="p-2">
                            <div className="flex gap-3">
                                <div className='w-40'>
                                    <input type="file" accept="image/*" name="" id="" className="hidden" onChange={handleImageChange} ref={imageUploadInputRef} />
                                    <div className='relative'>
                                        {data?.image && <ConfirmationModal
                                            buttonComponent={<div className='absolute right-1.5 top-1 z-[1]'> <IconTrashFilled size={20} color='#fa2a55' /> </div>}
                                            confirmationText={"Are you sure want to remove the Image?"}
                                            onConfirm={() => onRemoveImage()}
                                        />}
                                        <button onClick={() => imageUploadInputRef.current.click()} className='relative shadow rounded-md'>
                                            <img src={file ? URL.createObjectURL(file) : data?.image ? data?.image : (process.env.PUBLIC_URL + "/images/image-upload.png")} id='link-image-preview' className='cursor-pointer  rounded-lg object-cover' alt="" />
                                        </button>
                                    </div>
                                    <p className="text-xs text-gray-400">*Maximum size: 5MB, <br /> preferred ratio is 1:1</p>
                                </div>
                                <div className='w-full'>
                                    <p className="text-md font-semibold mb-1.5">Title & Description</p>
                                    <input type="text" className="form-control mb-2 w-full" placeholder="Enter Title" id='title' defaultValue={data?.title} maxLength={255} onChange={_debounce((e) => onTitleChange(e), 600)} />
                                    <input type="text" className="form-control w-full" placeholder="Enter Description (Optional) (Max 140 Words)" id='description' maxLength={140} defaultValue={data?.description} onChange={_debounce((e) => onDescriptionChange(e), 600)} />
                                </div>
                            </div>

                            <div>
                                <div className="flex gap-5 my-3">
                                    <div className='flex items-center'>
                                        <input type="radio" name="link-type-radio-btn" id="link-type-new" onChange={(e) => e.target.checked && setLinkTypeRadio('new')} defaultChecked={linkTypeRadio == "new"} />
                                        <label htmlFor="link-type-new" className="ml-2 font-medium">Create New Link</label>
                                    </div>
                                    <div className='flex items-center'>
                                        <input type="radio" name="link-type-radio-btn" id="link-type-existing" onChange={(e) => e.target.checked && setLinkTypeRadio('existing')} defaultChecked={linkTypeRadio == "existing"} />
                                        <label htmlFor="link-type-existing" className="ml-2 font-medium">Select Existing Link</label>
                                    </div>
                                </div>

                                {
                                    linkTypeRadio == 'new' && <div>
                                        <div className='mb-4'>
                                            <label htmlFor="" className='mb-1 font-semibold'>Destination URL</label>
                                            <input type="text" className="form-control w-full" id='destinationUrl' defaultValue={data?.link} onBlur={(e) => onLinkChange(e)} placeholder="Enter Link URL" />
                                        </div>
                                        <div className='flex flex-col'>
                                            <ShortLinkDropdown />
                                        </div>
                                    </div>
                                }
                                {
                                    linkTypeRadio == 'existing' && <div className='relative'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className='mb-1 font-semibold'>Select a Attriva link</label>
                                            <input type="text" className="hidden" id='destinationUrl' placeholder="Enter Link URL" />
                                            <div className='flex'>
                                                <input type="text" className="form-control w-full" placeholder="Search by back-half, destination, or title" defaultValue={searchInput} onChange={_debounce((e) => getList(e), 300)} id='search-existing-link-input' />
                                                {searchInput && <IconButton icon={< IconX />} onClickFunction={() => onCancel()} />}
                                            </div>
                                        </div>
                                        {linkList?.length > 0 && <div className="w-full max-h-[300px] overflow-y-auto absolute bg-white z-20 shadow-md p-2 pb-8 rounded-lg">
                                            {
                                                linkList.map((link, index) => (
                                                    <div key={index} className='border p-2 rounded-lg mb-2 cursor-pointer' onClick={() => onSelectLink(link)}>
                                                        <p className='text-sm font-medium mb-0'>{link.shortLink}</p>
                                                        <p className='text-xs font-normal mb-0'>{link.mainLink}</p>
                                                    </div>
                                                ))
                                            }
                                        </div>}
                                    </div>
                                }
                            </div>

                            {/* <div className="flex justify-end items-center mt-3 gap-3">
                                <button className="font-semibold text-sm border-2 border-primary px-3 py-1.5 rounded-full" onClick={() => onCancel()}>Cancel</button>
                                <button className="font-semibold text-sm text-white bg-primary px-3 py-2 rounded-full" onClick={() => create()}>Create</button>
                            </div> */}
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    )
}

export default LinkBlockOfCard